export const DEFAULT_DOCKING_OFFSET = 20;
export const DEFAULT_DOCKING_OFFSET_POPUP = 0;
